import { isSome, buildAuthorizedMenu } from 'core/utils';
import _ from 'lodash';

class MenuProvider {
	menus = [];

	initialize(menus, context) {
		this.menus = menus;
		this.context = context;

		const rootStore = this.context.rootStore;

		if (menus.length > 0 && !isSome(rootStore.routerStore.routes)) {
			throw new Error('Menu provider requires that root store routes are initialized - initialize RouteProvider');
		}

		const authMenu = this.buildMenu(rootStore, _.cloneDeep(menus), rootStore.routerStore.routes);
		rootStore.initializeMenu(authMenu);
	}

	refresh() {
		this.initialize(this.menus, this.context);
	}

	buildMenu(rootStore, menu, routes) {
		return buildAuthorizedMenu(menu, routes, rootStore.authStore.hasPermission);
	}
}

export default new MenuProvider();



// WEBPACK FOOTER //
// ./src/core/providers/menuProvider.js